module.exports = __webpack_public_path__ + "img/spi-icon.12c2d72d.svg";